// @flow
import { useEffect, useState } from 'react';

export function useScreenWidth(): number {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setScreenWidth]);

  return screenWidth;
}
